import { ValidationErrors } from '@angular/forms';

const EMAIL_ERROR_MESSAGES: ValidationErrors = {
  required: () => 'Email is required.',
  pattern: () => 'Please enter a valid email address.',
};

const PASSWORD_ERROR_MESSAGES: ValidationErrors = {
  required: () => 'Password is required.',
  minlength: () => 'Password must be at least 8 characters long.',
};

export const LOGIN_ERROR_MESSAGES = {
  email: EMAIL_ERROR_MESSAGES,
  password: PASSWORD_ERROR_MESSAGES,
} as const;
